import React, {useContext, useEffect, useState} from 'react';
import {Link} from 'react-router-dom';

import {ContextAuth} from '../../../common/context/context-auth';

import Loader from '../../../common/component/Loader/Loader';

import {Container, Row, Col, ListGroup} from 'react-bootstrap';

import * as IconFi from 'react-icons/fi';

import './More.scss';

const More = () => {
    const auth = useContext(ContextAuth);

    // -----------------------------------------------------------------------------------------------------------------

    const [data, setData] = useState([...auth.menu].slice(5, auth.menu.length))

    useEffect(() => {

        const fetchSvg = async () => {

            let dataTemp = [...data]

            try {

                const svgAll = await Promise.all(dataTemp.map(async item => {
                    const svg = await fetch(`/img/menu/${item.icon}.svg?${Date.now()}`);
                    return svg.text();
                }));

                svgAll.map((item, index) => dataTemp[index]['svg'] = item)

                setData(dataTemp)

            } catch (e) {
                console.log(e)
            }

        };

        if (!data[0].svg) fetchSvg()

    }, [])

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <div id="pageMore" className="mb-4 mb-xl-5">
            <Container fluid="lg" as="section">
                <Row>
                    <Col xs={12}>
                        {
                            data[0].svg ? (
                                <ListGroup variant="flush">
                                    {
                                        data.map(item => {
                                            return (
                                                <ListGroup.Item as={Link} to={`/${item.path}`} className="pe-0 ps-2 py-3 bg-transparent border-white-5 d-flex align-items-center" key={item.id}>
                                                    <figure dangerouslySetInnerHTML={{__html: item.svg}} className="mb-0 me-3 ratio ratio-1x1"/>
                                                    {item.title}
                                                    <IconFi.FiChevronLeft size={24} className="sw-1 ms-auto my-1 text-white text-opacity-18"/>
                                                </ListGroup.Item>
                                            )
                                        })
                                    }
                                </ListGroup>
                            ) : (
                                <div className="py-5 my-5">
                                    <Loader text="در حال دریافت اطلاعات"/>
                                </div>
                            )
                        }
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default More;